/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MediaPipelineStageFromJSON, MediaPipelineStageToJSON, } from './MediaPipelineStage';
import { MediaProcessingStatusFromJSON, MediaProcessingStatusToJSON, } from './MediaProcessingStatus';
import { UserProfileFromJSON, UserProfileToJSON, } from './UserProfile';
import { VirusScanStatusFromJSON, VirusScanStatusToJSON, } from './VirusScanStatus';
/**
 * Check if a given object implements the UserIncidentFile interface.
 */
export function instanceOfUserIncidentFile(value) {
    let isInstance = true;
    return isInstance;
}
export function UserIncidentFileFromJSON(json) {
    return UserIncidentFileFromJSONTyped(json, false);
}
export function UserIncidentFileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (json['deletedAt'] === null ? null : new Date(json['deletedAt'])),
        'rowVersion': !exists(json, 'rowVersion') ? undefined : json['rowVersion'],
        'discriminator': !exists(json, 'discriminator') ? undefined : json['discriminator'],
        'uploadFileName': !exists(json, 'uploadFileName') ? undefined : json['uploadFileName'],
        'uploadBucket': !exists(json, 'uploadBucket') ? undefined : json['uploadBucket'],
        'uploadObjectKey': !exists(json, 'uploadObjectKey') ? undefined : json['uploadObjectKey'],
        'uploadMimeType': !exists(json, 'uploadMimeType') ? undefined : json['uploadMimeType'],
        'isUploaded': !exists(json, 'isUploaded') ? undefined : json['isUploaded'],
        'uploadFileSize': !exists(json, 'uploadFileSize') ? undefined : json['uploadFileSize'],
        'processingStatus': !exists(json, 'processingStatus') ? undefined : MediaProcessingStatusFromJSON(json['processingStatus']),
        'virusScanStatus': !exists(json, 'virusScanStatus') ? undefined : VirusScanStatusFromJSON(json['virusScanStatus']),
        'isQuarantined': !exists(json, 'isQuarantined') ? undefined : json['isQuarantined'],
        'quarantineReason': !exists(json, 'quarantineReason') ? undefined : json['quarantineReason'],
        'checksumMd5': !exists(json, 'checksumMd5') ? undefined : json['checksumMd5'],
        'checksumSha256': !exists(json, 'checksumSha256') ? undefined : json['checksumSha256'],
        'userProfileId': !exists(json, 'userProfileId') ? undefined : json['userProfileId'],
        'userProfile': !exists(json, 'userProfile') ? undefined : UserProfileFromJSON(json['userProfile']),
        'createdBySubject': !exists(json, 'createdBySubject') ? undefined : json['createdBySubject'],
        'updatedBySubject': !exists(json, 'updatedBySubject') ? undefined : json['updatedBySubject'],
        'incidentReportId': !exists(json, 'incidentReportId') ? undefined : json['incidentReportId'],
        'processingStage': !exists(json, 'processingStage') ? undefined : MediaPipelineStageFromJSON(json['processingStage']),
        'processingStageUpdatedAt': !exists(json, 'processingStageUpdatedAt') ? undefined : (json['processingStageUpdatedAt'] === null ? null : new Date(json['processingStageUpdatedAt'])),
        'processingStartedAt': !exists(json, 'processingStartedAt') ? undefined : (json['processingStartedAt'] === null ? null : new Date(json['processingStartedAt'])),
        'processingFinishedAt': !exists(json, 'processingFinishedAt') ? undefined : (json['processingFinishedAt'] === null ? null : new Date(json['processingFinishedAt'])),
        'sourceSizeBytes': !exists(json, 'sourceSizeBytes') ? undefined : json['sourceSizeBytes'],
        'convertedSizeBytes': !exists(json, 'convertedSizeBytes') ? undefined : json['convertedSizeBytes'],
        'thumbnailObjectKey': !exists(json, 'thumbnailObjectKey') ? undefined : json['thumbnailObjectKey'],
        'previewObjectKey': !exists(json, 'previewObjectKey') ? undefined : json['previewObjectKey'],
        'convertedObjectKey': !exists(json, 'convertedObjectKey') ? undefined : json['convertedObjectKey'],
    };
}
export function UserIncidentFileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'isDeleted': value.isDeleted,
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt === null ? null : value.deletedAt.toISOString()),
        'rowVersion': value.rowVersion,
        'discriminator': value.discriminator,
        'uploadFileName': value.uploadFileName,
        'uploadBucket': value.uploadBucket,
        'uploadObjectKey': value.uploadObjectKey,
        'uploadMimeType': value.uploadMimeType,
        'isUploaded': value.isUploaded,
        'uploadFileSize': value.uploadFileSize,
        'processingStatus': MediaProcessingStatusToJSON(value.processingStatus),
        'virusScanStatus': VirusScanStatusToJSON(value.virusScanStatus),
        'isQuarantined': value.isQuarantined,
        'quarantineReason': value.quarantineReason,
        'checksumMd5': value.checksumMd5,
        'checksumSha256': value.checksumSha256,
        'userProfileId': value.userProfileId,
        'userProfile': UserProfileToJSON(value.userProfile),
        'createdBySubject': value.createdBySubject,
        'updatedBySubject': value.updatedBySubject,
        'incidentReportId': value.incidentReportId,
        'processingStage': MediaPipelineStageToJSON(value.processingStage),
        'processingStageUpdatedAt': value.processingStageUpdatedAt === undefined ? undefined : (value.processingStageUpdatedAt === null ? null : value.processingStageUpdatedAt.toISOString()),
        'processingStartedAt': value.processingStartedAt === undefined ? undefined : (value.processingStartedAt === null ? null : value.processingStartedAt.toISOString()),
        'processingFinishedAt': value.processingFinishedAt === undefined ? undefined : (value.processingFinishedAt === null ? null : value.processingFinishedAt.toISOString()),
        'sourceSizeBytes': value.sourceSizeBytes,
        'convertedSizeBytes': value.convertedSizeBytes,
        'thumbnailObjectKey': value.thumbnailObjectKey,
        'previewObjectKey': value.previewObjectKey,
        'convertedObjectKey': value.convertedObjectKey,
    };
}
